module.exports = __webpack_public_path__ + "static/media/feature-mass2.6cca4786.png";